<template>
   <div class="four-column-grid">
      <!-- Ana Yolcu Bilgileri -->
      <div class="item-container">
         <h4 class="section-title">{{ $t("modelDataViewer_lblTravellerBlock") }}</h4>
         <template v-for="(customer, index) in modelData.neoBooking.travellerBlock">
            <div class="child-container" :key="`travellerBlock-${index}`">
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblFirstName") }}</span> : {{ customer.firstName }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblLastName") }}</span> : {{ customer.lastName }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblStreet") }}</span> : {{ customer.street }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblLocation") }}</span> : {{ customer.location }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblZipCode") }}</span> : {{ customer.zipCode }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblTelephone") }}</span> : {{ customer.telephone }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblEmail") }}</span> : {{ customer.email }}
               </span>
            </div>
         </template>
      </div>
      <!-- Kişi Bilgileri -->
      <div class="item-container">
         <h4 class="section-title">{{ $t("modelDataViewer_lblPersonResponseRows") }}</h4>
         <template v-for="(person, index) in modelData.neoBooking.personResponseBlock.personResponseRows">
            <div class="child-container" :key="`travellerBlock-${index}`">
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblName") }}</span> : {{ person.name }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblAge") }}</span> : {{ handlerAgeCalc(person.age) }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblBirthdate") }}</span> : {{ formattedDate(person.age) }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblSalutation") }}</span> : {{ person.salutation }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblTravellerNo") }}</span> : {{ person.travellerNo }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblPrice") }}</span> : {{ person.price }}
               </span>
            </div>
         </template>
      </div>
      <!-- Seyahat Özet -->
      <div class="item-container">
         <h4 class="section-title">{{ $t("modelDataViewer_lblHints") }}</h4>
         <template v-for="(hint, index) in modelData.neoBooking.hints.hints">
            <div class="child-container" :key="`hints-${index}`">
               <span class="flex-row">{{ hint.text }}</span>
            </div>
         </template>
      </div>
      <!-- Zaman Bilgisi -->
      <div class="item-container">
         <h4 class="section-title">{{ $t("modelDataViewer_lblTimeStamp") }}</h4>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblTimeStampDate") }}</span> : {{ formattedDate(modelData.timeStamp.date) }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblTimeStampTime") }}</span> : {{ modelData.timeStamp.time }}
         </span>
      </div>
      <!-- Genel Bilgiler -->
      <div class="item-container">
         <h4 class="section-title">{{ $t("modelDataViewer_lblGeneralInfo") }}</h4>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblTerminal") }}</span> : {{ modelData.terminal }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblAgencyTerminal") }}</span> : {{ modelData.agencyTerminal }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblUser") }}</span> : {{ modelData.user }}
         </span>
      </div>
      <!-- Durum -->
      <div class="item-container">
         <h4 class="section-title">{{ $t("modelDataViewer_lblStatus") }}</h4>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblMessageNo") }}</span> : {{ modelData.neoBooking.status.messageNo }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblMessageText") }}</span> : {{ modelData.neoBooking.status.messageText }}
         </span>
      </div>
      <!-- Neo Booking -->
      <div class="item-container">
         <h4 class="section-title">{{ $t("modelDataViewer_lblNeoBooking") }}</h4>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblTourOperator") }}</span> : {{ modelData.neoBooking.tourOperator }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblTravelType") }}</span> : {{ modelData.neoBooking.travelType }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblNoOfPersons") }}</span> : {{ modelData.neoBooking.noOfPersons }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblAgencyNoTouroperator") }}</span> : {{ modelData.neoBooking.agencyNoTouroperator }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblReservationNo") }}</span> : {{ modelData.neoBooking.reservationNo }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblModuleNo") }}</span> : {{ modelData.neoBooking.moduleNo }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblConsultant") }}</span> : {{ modelData.neoBooking.consultant }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblRemark") }}</span> : {{ modelData.neoBooking.remark }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblTotalPrice") }}</span> : {{ modelData.neoBooking.totalPrice | price(modelData.neoBooking.isoCurrency) }}
         </span>
         <span class="flex-row">
            <span class="model-data-title">{{ $t("modelDataViewer_lblEndDateOfTravel") }}</span> : {{ formattedDate(modelData.neoBooking.endDateOfTravel) }}
         </span>
      </div>
      <!-- Servis Yanıtı -->
      <div class="item-container">
         <h4 class="section-title">{{ $t("modelDataViewer_lblServiceResponseRows") }}</h4>
         <template v-for="(service, index) in modelData.neoBooking.serviceResponseBlock.serviceResponseRows">
            <div class="child-container" :key="`service-${index}`">
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblPositionNo") }}</span> : {{ service.positionNo }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblMarkField") }}</span> : {{ service.markField }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblKindOfService") }}</span> : {{ service.kindOfService }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblService") }}</span> : {{ service.service }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblAccommodation") }}</span> : {{ service.accommodation }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblOccupancy") }}</span> : {{ service.occupancy }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblNoOfServices") }}</span> : {{ service.noOfServices }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblFromDate") }}</span> : {{ formattedDate(service.fromDate) }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblEndDate") }}</span> : {{ formattedDate(service.endDate) }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblTravellerAllocation") }}</span> : {{ service.travellerAllocation }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblStatusOfService") }}</span> : {{ service.statusOfService }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblServicePrice") }}</span> : {{ service.servicePrice }}
               </span>
               <span class="flex-row">
                  <span class="model-data-title">{{ $t("modelDataViewer_lblStealBoarding") }}</span> : {{ service.stealBoarding }}
               </span>
            </div>
         </template>
      </div>
   </div>
</template>

<script>
export default {
   name: "ModelDataViewer",
   props: {
      modelData: {
         type: Object,
      },
   },
   methods: {
      formattedDate(date) {
         if (!date || date === "") {
            return "";
         }
         return `${date.slice(0, 2)}/${date.slice(2, 4)}/${date.slice(4, 6)}`;
      },
      handlerAgeCalc(age) {
         if (!age || age === "") {
            return "";
         }

         const day = parseInt(age.slice(0, 2), 10);
         const month = parseInt(age.slice(2, 4), 10) - 1;
         let year = parseInt(age.slice(4, 6), 10);
         const currentYear = new Date().getFullYear();
         const currentCentury = Math.floor(currentYear / 100) * 100;

         year += year > currentYear % 100 ? currentCentury - 100 : currentCentury;

         const birthDate = new Date(year, month, day);
         const today = new Date();
         let currentAge = today.getFullYear() - birthDate.getFullYear();
         const monthDiff = today.getMonth() - birthDate.getMonth();
         if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            currentAge--;
         }
         return currentAge;
      },
   },
};
</script>

<style scoped lang="scss">
.four-column-grid {
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   gap: 16px;

   .item-container {
      background: var(--accent-gray-darker);
      border-radius: 10px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);

      .section-title {
         font-size: 1.25rem;
         font-weight: 700;
         margin-bottom: 8px;
      }

      .flex-row {
         display: flex;
         flex-direction: column;

         .model-data-title {
            font-weight: 600;
         }
      }

      .child-container {
         background: var(--accent-gray-darkest);
         border-radius: 10px;
         padding: 16px;
         margin-bottom: 8px;
         display: flex;
         flex-direction: column;
         box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
      }
   }
}
</style>
